import { FormGroup, ValidationErrors } from '@angular/forms';

export class FormGroupExtended extends FormGroup {
  warnings: ValidationErrors | null = null;
  private _isSubmitted = false;

  public get isSubmitted(): boolean {
    if (this.parent != null) {
      this._isSubmitted = (this.parent as FormGroupExtended).isSubmitted;
    }

    return this._isSubmitted;
  }

  public set isSubmitted(value: boolean) {
    if (this.parent != null) {
      (this.parent as FormGroupExtended).isSubmitted = value;
    }

    this._isSubmitted = value;
  }
}
